import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class VersionService {

  static getVersions() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}versions`).then((data) => {
        resolve({ versions: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default VersionService;
